export function isMaintenanceFormEmpty(props) {
    return !props.header || !props.buttonText;
}
export const prepareMaintenanceFormLabels = (labels) => {
    return {
        firstNameLabel: labels?.maintenanceForm_firstName_label,
        firstNamePlaceholder: labels?.maintenanceForm_firstName_placeholder,
        lastNameLabel: labels?.maintenanceForm_lastName_label,
        lastNamePlaceholder: labels?.maintenanceForm_lastName_placeholder,
        emailLabel: labels?.maintenanceForm_email_label,
        emailPlaceholder: labels?.maintenanceForm_email_placeholder,
        phoneLabel: labels?.maintenanceForm_phone_label,
        phonePlaceholder: labels?.maintenanceForm_phone_placeholder,
        incorrectEmailError: labels?.checkout_incorrectEmail_error,
        requiredFieldError: labels?.checkout_personalDetailsRequiredField_error,
        phoneError: labels?.checkout_personalDetailsPhone_error,
        successLabel: labels?.common_success_label,
        successPopUpMessage: labels?.common_formSuccessPopUp_message,
        myVehicleLabel: labels?.maintenanceForm_description_label,
        dateLabel: labels?.maintenanceForm_preferredDate_label,
        timeLabel: labels?.maintenanceForm_preferredTime_label,
        myVehiclePlaceholder: labels?.maintenanceForm_description_placeholder,
        somethingWentWrongMessage: labels?.common_somethingWentWrong_message,
        preferredContactMethodEmail: labels?.maintenanceForm_preferredContactMethod_email,
        preferredContactMethodLabel: labels?.common_personalDetailsPreferredContactMethod_label,
        preferredContactMethodPhone: labels?.maintenanceForm_preferredContactMethod_phone,
        vehicleLicensePlateeLabel: labels?.maintenanceForm_vehicleLicensePlateNumber_label,
        vehicleKMLabel: labels?.maintenanceForm_vehicleKm_label,
        preferredTimeLabel: labels?.maintenanceForm_preferredTime_label,
        preferredDateLabel: labels?.maintenanceForm_preferredDate_label,
        modelNameLabel: labels?.maintenanceForm_modelName_label,
        modelNamePlaceholder: labels?.maintenanceForm_modelName_placeholder,
        vehicleLicensePlateePlaceholder: labels?.maintenanceForm_vehicleLicensePlateNumber_placeholder,
        vehicleKMPlaceholder: labels?.maintenanceForm_vehicleKm_placeholder,
        preferredContactMethodMap: labels?.common_personalDetailsPreferredContactMethod_map,
        vehicleKmError: labels?.maintenanceForm_vehicleKm_error,
    };
};
